import { Button, Result } from 'antd'
import { useNavigate } from 'react-router'

export function NotFoundPage() {
  const navigate = useNavigate()
  return (
    <Result
      status="404"
      title="404"
      subTitle="Không tìm thấy trang."
      extra={<Button onClick={() => navigate('/')}>Về trang chủ</Button>}
    />
  )
}
